/**
 * Returns the correct API base path for editor operations.
 *
 * - Dev mode: `/__api` (Vite middleware)
 * - Editor build: `/api/editor` (Vercel serverless functions)
 */
export function editorApiBase(): string {
  if (import.meta.env.DEV) return "/__api";
  return "/api/editor";
}
